import React from 'react';

export default function Bannershape() {
  return (
    <div className="shaper-div">
      <div className="shape"></div>
    </div>  
   )
  
}